import request from '../utils/request'
import { ParamsProps, ReturnType } from './types'

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'categories',
      method: 'get',
      params: args?.params,
      authorization: false,
      config: {
        showErr: true,
      },
    }
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: 'set',
      }
    }
    const response = await request(config)
    return response
  } catch (err) {
    throw new Error(err)
  }
}

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'categories',
      method: 'post',
      data: args?.data,
      authorization: true,
      config: {
        successMsg: 'Create Successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'prepend',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err) {
    throw new Error(err)
  }
}

const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `categories/${args?.id}`,
      method: 'patch',
      data: args?.data,
      authorization: true,
      config: {
        successMsg: 'Update Successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err) {
    throw new Error(err)
  }
}

const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `categories/${args?.id}`,
      method: 'delete',
      authorization: true,
      config: {
        successMsg: 'Deleted Successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'remove',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err) {
    throw new Error(err)
  }
}

export default {
  list,
  create,
  update,
  remove,
}
